<div class="modal-header">
    <h4 class="modal-title">Edit Tender Information</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="close()">
    </button>
</div>

<div class="modal-body">
    <form [formGroup]="form" (ngSubmit)="save()">
        <div class="row">
            <div class="col-12">
                <div class="mb-3">
                    <label for="tenderName" class="form-label">Tender Name <span class="text-danger">*</span></label>
                    <input
                        type="text"
                        class="form-control"
                        id="tenderName"
                        formControlName="name"
                        [class.is-invalid]="form.get('name')?.invalid && form.get('name')?.touched"
                        placeholder="Enter tender name">
                    <div class="invalid-feedback" *ngIf="form.get('name')?.invalid && form.get('name')?.touched">
                        Tender name is required
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="mb-3">
                    <label for="coverLetterText" class="form-label">Tender Invitation Letter</label>
                    <textarea
                        class="form-control"
                        id="coverLetterText"
                        formControlName="cover_letter_text"
                        rows="8"
                        placeholder="Enter the text of your tender invitation letter here">
                    </textarea>
                    <div class="form-text">
                        This text will be displayed to suppliers when they view the tender invitation.
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="close()" [disabled]="loading">
        Cancel
    </button>
    <button
        type="button"
        class="btn btn-primary"
        (click)="save()"
        [disabled]="form.invalid || loading"
        [ngbPopover]="getFirstFormGroupErrorLabel(form)"
        triggers="mouseenter:mouseleave"
        placement="left">
        <span *ngIf="loading">
            <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
            <span>Saving...</span>
        </span>
        <span *ngIf="!loading">
            <i class="fas fa-save me-1"></i>
            <span>Save Changes</span>
        </span>
    </button>
</div>
